/**
 * Whether a persisted simulation can still be resumed.
 *
 * The session carries an overlay of documents that only exist in memory, and
 * that overlay is designed to sit on top of LIVE reads of the agent, the
 * acquisition order and the monetization orders. Resume one against a
 * configuration edited since and the page shows a mixture of the two, which
 * reads as a bug in the agent rather than a stale session.
 *
 * The stamp is compared, not trusted: a mismatch means start again.
 */
export const isSessionValid = (session, target) => {
  if (!session || !session.stamp || !target) return false;
  const { stamp } = session;
  return (
    stamp.agentId === target.agentId &&
    stamp.acquisitionOrderId === target.acquisitionOrderId &&
    (stamp.agentUpdatedAt || 0) === (target.agentUpdatedAtMs || 0)
  );
};

export default isSessionValid;
